import { ClinicNavigationEnum } from '@core/enums/navigation.enum';
import { INavigation } from '@core/interfaces/interface';

export const navigationClinic: INavigation[] = [
  {
    title: '',
    patch: `/`,
    icon: 'bi-house-fill',
    sublist: [],
    expanded: false,
    endpoint: true,
  },
  {
    title: 'staff_office',
    icon: 'bi-person',
    patch: ClinicNavigationEnum.staff_info,
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'doctor_office',
    icon: 'bi-activity',
    patch: ClinicNavigationEnum.office,
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'calendar',
    icon: 'bi-calendar-check-fill',
    patch: ClinicNavigationEnum.calendar,
    sublist: [],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'telediagnosis_old',
    icon: 'bi-heart',
    patch: ClinicNavigationEnum.telediagnosis_old,
    sublist: [
      {
        title: 'measurements',
        patch: ClinicNavigationEnum.telediagnosis_old + '/' + ClinicNavigationEnum.list,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
    ],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'telediagnosis',
    icon: 'bi-tools',
    patch: ClinicNavigationEnum.telediagnosis,
    sublist: [
      {
        title: 'measurements',
        patch: ClinicNavigationEnum.telediagnosis + '/' + ClinicNavigationEnum.list,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
    ],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'setting',
    icon: 'bi-gear',
    patch: ClinicNavigationEnum.setting,
    sublist: [
      {
        title: 'rehabilitation_team',
        patch: ClinicNavigationEnum.setting + '/' + ClinicNavigationEnum.setting_team,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
    ],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'examination_card',
    icon: 'bi-card-list',
    patch: ClinicNavigationEnum.card,
    sublist: [
      {
        title: 'patients',
        patch: ClinicNavigationEnum.card + '/' + ClinicNavigationEnum.patient,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
      {
        title: 'my_cards',
        patch: ClinicNavigationEnum.card + '/' + ClinicNavigationEnum.staff,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
    ],
    expanded: false,
    endpoint: false,
  },
  {
    title: 'physician_assistant.title_doctor',
    icon: 'bi-robot',
    patch: ClinicNavigationEnum.physician_assistant,
    sublist: [
      {
        title: 'materials',
        patch: ClinicNavigationEnum.physician_assistant + '/' + ClinicNavigationEnum.physician_assistant_materials,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
      {
        title: 'ai_chat',
        patch: ClinicNavigationEnum.physician_assistant + '/' + ClinicNavigationEnum.physician_assistant_chat,
        sublist: [],
        expanded: false,
        endpoint: true,
      },
    ],
    expanded: false,
    endpoint: false,
  },
];
